import React from "react"
import {
  AspectRatio, Box, Flex, Image, Stack, Text,
} from "@chakra-ui/react"
import NewTextMenu from "pages/EventShow/Texts/NewTextMenu"
import DashboardCard, { LinkAction } from "../components/DashboardCard"

export type QuickAction = {
  label: string
  icon: string
  onClick?: () => void
  to?: string
  href?: string
  textMenu?: boolean
}

type Props = {
  coverImageUrl?: string
  canEditImage: boolean
  onUploadImage: () => void
  groups: { title: string, actions: QuickAction[] }[]
}

const QuickActionsCard = ({
  coverImageUrl, canEditImage, onUploadImage, groups,
}: Props) => (
  <DashboardCard title="Quick Actions">
    <Stack spacing={6}>
      {canEditImage && (
      <Flex justify="space-between" align="flex-start" gap={3}>
        <Box>
          <Text fontSize="xs" fontWeight="semibold" color="gray.600" mb={1}>Event image</Text>
          <LinkAction icon="email-block-image" onClick={onUploadImage}>
            {coverImageUrl ? "Upload new image" : "Upload image"}
          </LinkAction>
        </Box>
        {coverImageUrl && (
        <AspectRatio ratio={16 / 9} w="96px" flexShrink={0} borderRadius="md" overflow="hidden" borderWidth={1}>
          <Image src={`${coverImageUrl}?fit=crop&w=192&h=108`} alt="Event image" objectFit="cover" />
        </AspectRatio>
        )}
      </Flex>
      )}
      {groups.filter(({ actions }) => actions.length).map(({ title, actions }) => (
        <Box key={title}>
          <Text fontSize="xs" fontWeight="semibold" color="gray.600" mb={1}>{title}</Text>
          <Stack spacing={1.5} align="flex-start">
            {actions.map(({ label, textMenu, ...action }) => (textMenu ? (
              <NewTextMenu
                key={label}
                placement="bottom-start"
                button={<LinkAction icon={action.icon}>{label}</LinkAction>}
              />
            ) : (
              <LinkAction key={label} {...action}>{label}</LinkAction>
            )))}
          </Stack>
        </Box>
      ))}
    </Stack>
  </DashboardCard>
)

export default QuickActionsCard
